import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Button, Stack,Backdrop,CircularProgress } from '@mui/material';



const API = require("../../data/network/API");

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  maxWidth: 400,
  borderRadius:16,
  color: theme.palette.text.primary,
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.primary.secondary,
  }),
}));



export default function Rewards() {

  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  const getRewards = async () => {
    setOpen(true)

    const response = await API.getRewards()
    setOpen(false)
    if(response.status == 200){
      console.log(response.body)
      setRows(response.body.data)
    }else{

    }
  }

  React.useEffect(()=>{ 
    getRewards()
  },[])

  return (
    <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3 }}>
      {rows?.map((row) => ( 
      <StyledPaper sx={{ my: 1, mx: 'auto', p: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <img
              width="100%"
              srcSet={row.imagen_url}
              src={row.imagen_url}
              alt='Breakfast'
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Stack spacing={2} sx={{width:"100%"}}>
              <Typography variant="h6" sx={{fontWeight:"bold"}}>{row.nombre}</Typography>
              <Typography variant="body1">{row.descripcion}
              </Typography>
              <Typography sx={{fontSize: 18, fontWeight: "bold", color: "#00a152"}}>{row.puntos} Puntos</Typography>
              <Button variant="contained" fullWidth color="secondary">
                ver más
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </StyledPaper>
      ))}
      <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={open}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}